var _regeneratorRuntime = require("/opt/build/repo/node_modules/@babel/runtime/regenerator");

var _classCallCheck = require("/opt/build/repo/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/opt/build/repo/node_modules/@babel/runtime/helpers/createClass");

var _inherits = require("/opt/build/repo/node_modules/@babel/runtime/helpers/inherits");

var _possibleConstructorReturn = require("/opt/build/repo/node_modules/@babel/runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("/opt/build/repo/node_modules/@babel/runtime/helpers/getPrototypeOf");

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

!function (e, t) {
  if ("object" == typeof exports && "object" == typeof module) module.exports = t();else if ("function" == typeof define && define.amd) define([], t);else {
    var n = t();

    for (var r in n) {
      ("object" == typeof exports ? exports : e)[r] = n[r];
    }
  }
}(window, function () {
  return function (e) {
    var t = {};

    function n(r) {
      if (t[r]) return t[r].exports;
      var o = t[r] = {
        i: r,
        l: !1,
        exports: {}
      };
      return e[r].call(o.exports, o, o.exports, n), o.l = !0, o.exports;
    }

    return n.m = e, n.c = t, n.d = function (e, t, r) {
      n.o(e, t) || Object.defineProperty(e, t, {
        enumerable: !0,
        get: r
      });
    }, n.r = function (e) {
      "undefined" != typeof Symbol && Symbol.toStringTag && Object.defineProperty(e, Symbol.toStringTag, {
        value: "Module"
      }), Object.defineProperty(e, "__esModule", {
        value: !0
      });
    }, n.t = function (e, t) {
      if (1 & t && (e = n(e)), 8 & t) return e;
      if (4 & t && "object" == typeof e && e && e.__esModule) return e;
      var r = Object.create(null);
      if (n.r(r), Object.defineProperty(r, "default", {
        enumerable: !0,
        value: e
      }), 2 & t && "string" != typeof e) for (var o in e) {
        n.d(r, o, function (t) {
          return e[t];
        }.bind(null, o));
      }
      return r;
    }, n.n = function (e) {
      var t = e && e.__esModule ? function () {
        return e.default;
      } : function () {
        return e;
      };
      return n.d(t, "a", t), t;
    }, n.o = function (e, t) {
      return Object.prototype.hasOwnProperty.call(e, t);
    }, n.p = "", n(n.s = 5);
  }([function (e, t, n) {
    e.exports = n(8)();
  }, function (e, t, n) {
    "use strict";

    e.exports = n(6);
  }, function (e, t) {
    var n = "undefined" != typeof crypto && crypto.getRandomValues && crypto.getRandomValues.bind(crypto) || "undefined" != typeof msCrypto && "function" == typeof window.msCrypto.getRandomValues && msCrypto.getRandomValues.bind(msCrypto);

    if (n) {
      var r = new Uint8Array(16);

      e.exports = function () {
        return n(r), r;
      };
    } else {
      var o = new Array(16);

      e.exports = function () {
        for (var e, t = 0; t < 16; t++) {
          0 == (3 & t) && (e = 4294967296 * Math.random()), o[t] = e >>> ((3 & t) << 3) & 255;
        }

        return o;
      };
    }
  }, function (e, t) {
    for (var n = [], r = 0; r < 256; ++r) {
      n[r] = (r + 256).toString(16).substr(1);
    }

    e.exports = function (e, t) {
      var r = t || 0,
          o = n;
      return [o[e[r++]], o[e[r++]], o[e[r++]], o[e[r++]], "-", o[e[r++]], o[e[r++]], "-", o[e[r++]], o[e[r++]], "-", o[e[r++]], o[e[r++]], "-", o[e[r++]], o[e[r++]], o[e[r++]], o[e[r++]], o[e[r++]], o[e[r++]]].join("");
    };
  }, function (e, t, n) {
    var r = n(10),
        o = n(11),
        u = o;
    u.v1 = r, u.v4 = o, e.exports = u;
  }, function (e, t, n) {
    "use strict";

    n.r(t), n.d(t, "default", function () {
      return l;
    });
    var r = n(1),
        o = n.n(r),
        u = n(0),
        i = n.n(u),
        c = n(4);

    function a() {
      return (a = Object.assign || function (e) {
        for (var t = 1; t < arguments.length; t++) {
          var n = arguments[t];

          for (var r in n) {
            Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
          }
        }

        return e;
      }).apply(this, arguments);
    }

    function s(e, t, n, r, o, u, i) {
      try {
        var c = e[u](i),
            a = c.value;
      } catch (e) {
        return void n(e);
      }

      c.done ? t(a) : Promise.resolve(a).then(r, o);
    }

    var l = /*#__PURE__*/function (_o$a$Component) {
      _inherits(l, _o$a$Component);

      var _super = _createSuper(l);

      function l() {
        var _this;

        _classCallCheck(this, l);

        var t;

        for (var _len = arguments.length, e = new Array(_len), _key = 0; _key < _len; _key++) {
          e[_key] = arguments[_key];
        }

        return _possibleConstructorReturn(_this, (t = _this = _super.call.apply(_super, [this].concat(e)), _this.state = {
          isEventbriteLoaded: !1
        }, _this.elementId = Object(c.v4)(), _this.fetchEBWidgets = function () {
          return new Promise(function (e, t) {
            if (window.EBWidgets) return e(window.EBWidgets);
            var n = _this.props.ebScriptPath,
                r = document.createElement("script");
            r.id = _this.scriptId, r.async = !0, r.src = n, r.addEventListener("load", function () {
              return e(window.EBWidgets);
            });

            var o = function o(e) {
              console.error("Failed to load Eventbrite script from ".concat(n)), t(e);
            };

            r.addEventListener("error", o), r.addEventListener("abort", o), document.head.appendChild(r);
          });
        }, _this.handleClick = function (e) {
          if (_this.props.onClick && _this.props.onClick(e), _this.state.isEventbriteLoaded) return;
          var t = "https://www.eventbrite.com/e/".concat(_this.props.ebEventId);
          window.open(t, "_blank");
        }, t));
      }

      _createClass(l, [{
        key: "scriptId",
        get: function get() {
          return "eb-script-".concat(this.elementId);
        }
      }, {
        key: "buttonId",
        get: function get() {
          return "eb-button-".concat(this.elementId);
        }
      }, {
        key: "componentWillMount",
        value: function componentWillMount() {
          var e,
              t = this;
          return (e = /*#__PURE__*/_regeneratorRuntime.mark(function e() {
            return _regeneratorRuntime.wrap(function e$(_context) {
              while (1) {
                switch (_context.prev = _context.next) {
                  case 0:
                    _context.prev = 0;
                    _context.next = 3;
                    return t.fetchEBWidgets();

                  case 3:
                    _context.sent.createWidget({
                      widgetType: "checkout",
                      eventId: t.props.ebEventId,
                      modal: t.props.isModal,
                      modalTriggerElementId: t.buttonId,
                      onOrderComplete: t.props.onOrderComplete
                    });

                    t.setState({
                      isEventbriteLoaded: !0
                    });
                    _context.next = 10;
                    break;

                  case 7:
                    _context.prev = 7;
                    _context.t0 = _context["catch"](0);
                    t.setState({
                      isEventbriteLoaded: !1
                    });

                  case 10:
                  case "end":
                    return _context.stop();
                }
              }
            }, e, null, [[0, 7]]);
          }), function () {
            var t = this,
                n = arguments;
            return new Promise(function (r, o) {
              var u = e.apply(t, n);

              function i(e) {
                s(u, r, o, i, c, "next", e);
              }

              function c(e) {
                s(u, r, o, i, c, "throw", e);
              }

              i(void 0);
            });
          })();
        }
      }, {
        key: "componentWillUnmount",
        value: function componentWillUnmount() {
          var e = document.getElementById(this.scriptId);
          e && e.remove();
        }
      }, {
        key: "render",
        value: function render() {
          var _this$props = this.props,
              e = _this$props.children,
              t = _this$props.className,
              n = _this$props.component,
              r = _this$props.componentProps;
          return o.a.createElement(n, a({
            id: this.buttonId,
            className: t,
            onClick: this.handleClick
          }, r), e);
        }
      }]);

      return l;
    }(o.a.Component);

    l.propTypes = {
      className: i.a.string,
      ebEventId: i.a.string.isRequired,
      ebScriptPath: i.a.string,
      isModal: i.a.bool,
      onOrderComplete: i.a.func,
      onClick: i.a.func,
      component: i.a.node,
      componentProps: i.a.shape({})
    }, l.defaultProps = {
      className: "",
      ebScriptPath: "https://www.eventbrite.ca/static/widgets/eb_widgets.js",
      isModal: !0,
      onOrderComplete: function onOrderComplete() {},
      component: "button",
      componentProps: {}
    };
  }, function (e, t, n) {
    "use strict";
    /** @license React v16.8.6
     * react.production.min.js
     *
     * Copyright (c) Facebook, Inc. and its affiliates.
     *
     * This source code is licensed under the MIT license found in the
     * LICENSE file in the root directory of this source tree.
     */

    var r = n(7),
        o = "function" == typeof Symbol && Symbol.for,
        u = o ? Symbol.for("react.element") : 60103,
        i = o ? Symbol.for("react.portal") : 60106,
        c = o ? Symbol.for("react.fragment") : 60107,
        a = o ? Symbol.for("react.strict_mode") : 60108,
        s = o ? Symbol.for("react.profiler") : 60114,
        l = o ? Symbol.for("react.provider") : 60109,
        f = o ? Symbol.for("react.context") : 60110,
        p = o ? Symbol.for("react.concurrent_mode") : 60111,
        d = o ? Symbol.for("react.forward_ref") : 60112,
        y = o ? Symbol.for("react.suspense") : 60113,
        v = o ? Symbol.for("react.memo") : 60115,
        m = o ? Symbol.for("react.lazy") : 60116,
        b = "function" == typeof Symbol && Symbol.iterator;

    function h(e) {
      for (var t = arguments.length - 1, n = "https://reactjs.org/docs/error-decoder.html?invariant=" + e, r = 0; r < t; r++) {
        n += "&args[]=" + encodeURIComponent(arguments[r + 1]);
      }

      !function (e, t, n, r, o, u, i, c) {
        if (!e) {
          if (e = void 0, void 0 === t) e = Error("Minified exception occurred; use the non-minified dev environment for the full error message and additional helpful warnings.");else {
            var a = [n, r, o, u, i, c],
                s = 0;
            (e = Error(t.replace(/%s/g, function () {
              return a[s++];
            }))).name = "Invariant Violation";
          }
          throw e.framesToPop = 1, e;
        }
      }(!1, "Minified React error #" + e + "; visit %s for the full message or use the non-minified dev environment for full errors and additional helpful warnings. ", n);
    }

    var g = {
      isMounted: function isMounted() {
        return !1;
      },
      enqueueForceUpdate: function enqueueForceUpdate() {},
      enqueueReplaceState: function enqueueReplaceState() {},
      enqueueSetState: function enqueueSetState() {}
    },
        w = {};

    function O(e, t, n) {
      this.props = e, this.context = t, this.refs = w, this.updater = n || g;
    }

    function _() {}

    function S(e, t, n) {
      this.props = e, this.context = t, this.refs = w, this.updater = n || g;
    }

    O.prototype.isReactComponent = {}, O.prototype.setState = function (e, t) {
      "object" != typeof e && "function" != typeof e && null != e && h("85"), this.updater.enqueueSetState(this, e, t, "setState");
    }, O.prototype.forceUpdate = function (e) {
      this.updater.enqueueForceUpdate(this, e, "forceUpdate");
    }, _.prototype = O.prototype;
    var j = S.prototype = new _();
    j.constructor = S, r(j, O.prototype), j.isPureReactComponent = !0;
    var E = {
      current: null
    },
        P = {
      current: null
    },
        k = Object.prototype.hasOwnProperty,
        x = {
      key: !0,
      ref: !0,
      __self: !0,
      __source: !0
    };

    function C(e, t, n) {
      var r = void 0,
          o = {},
          i = null,
          c = null;
      if (null != t) for (r in void 0 !== t.ref && (c = t.ref), void 0 !== t.key && (i = "" + t.key), t) {
        k.call(t, r) && !x.hasOwnProperty(r) && (o[r] = t[r]);
      }
      var a = arguments.length - 2;
      if (1 === a) o.children = n;else if (1 < a) {
        for (var s = Array(a), l = 0; l < a; l++) {
          s[l] = arguments[l + 2];
        }

        o.children = s;
      }
      if (e && e.defaultProps) for (r in a = e.defaultProps) {
        void 0 === o[r] && (o[r] = a[r]);
      }
      return {
        $$typeof: u,
        type: e,
        key: i,
        ref: c,
        props: o,
        _owner: P.current
      };
    }

    function I(e) {
      return "object" == typeof e && null !== e && e.$$typeof === u;
    }

    var R = /\/+/g,
        $ = [];

    function T(e, t, n, r) {
      if ($.length) {
        var o = $.pop();
        return o.result = e, o.keyPrefix = t, o.func = n, o.context = r, o.count = 0, o;
      }

      return {
        result: e,
        keyPrefix: t,
        func: n,
        context: r,
        count: 0
      };
    }

    function M(e) {
      e.result = null, e.keyPrefix = null, e.func = null, e.context = null, e.count = 0, 10 > $.length && $.push(e);
    }

    function L(e, t, n) {
      return null == e ? 0 : function e(t, n, r, o) {
        var c = typeof t;
        "undefined" !== c && "boolean" !== c || (t = null);
        var a = !1;
        if (null === t) a = !0;else switch (c) {
          case "string":
          case "number":
            a = !0;
            break;

          case "object":
            switch (t.$$typeof) {
              case u:
              case i:
                a = !0;
            }

        }
        if (a) return r(o, t, "" === n ? "." + q(t, 0) : n), 1;
        if (a = 0, n = "" === n ? "." : n + ":", Array.isArray(t)) for (var s = 0; s < t.length; s++) {
          var l = n + q(c = t[s], s);
          a += e(c, l, r, o);
        } else if (l = null === t || "object" != typeof t ? null : "function" == typeof (l = b && t[b] || t["@@iterator"]) ? l : null, "function" == typeof l) for (t = l.call(t), s = 0; !(c = t.next()).done;) {
          a += e(c = c.value, l = n + q(c, s++), r, o);
        } else "object" === c && h("31", "[object Object]" == (r = "" + t) ? "object with keys {" + Object.keys(t).join(", ") + "}" : r, "");
        return a;
      }(e, "", t, n);
    }

    function q(e, t) {
      return "object" == typeof e && null !== e && null != e.key ? function (e) {
        var t = {
          "=": "=0",
          ":": "=2"
        };
        return "$" + ("" + e).replace(/[=:]/g, function (e) {
          return t[e];
        });
      }(e.key) : t.toString(36);
    }

    function A(e, t) {
      e.func.call(e.context, t, e.count++);
    }

    function W(e, t, n) {
      var r = e.result,
          o = e.keyPrefix;
      e = e.func.call(e.context, t, e.count++), Array.isArray(e) ? U(e, r, n, function (e) {
        return e;
      }) : null != e && (I(e) && (e = function (e, t) {
        return {
          $$typeof: u,
          type: e.type,
          key: t,
          ref: e.ref,
          props: e.props,
          _owner: e._owner
        };
      }(e, o + (!e.key || t && t.key === e.key ? "" : ("" + e.key).replace(R, "$&/") + "/") + n)), r.push(e));
    }

    function U(e, t, n, r, o) {
      var u = "";
      null != n && (u = ("" + n).replace(R, "$&/") + "/"), L(e, W, t = T(t, u, r, o)), M(t);
    }

    function N() {
      var e = E.current;
      return null === e && h("321"), e;
    }

    var V = {
      Children: {
        map: function map(e, t, n) {
          if (null == e) return e;
          var r = [];
          return U(e, r, null, t, n), r;
        },
        forEach: function forEach(e, t, n) {
          if (null == e) return e;
          L(e, A, t = T(null, null, t, n)), M(t);
        },
        count: function count(e) {
          return L(e, function () {
            return null;
          }, null);
        },
        toArray: function toArray(e) {
          var t = [];
          return U(e, t, null, function (e) {
            return e;
          }), t;
        },
        only: function only(e) {
          return I(e) || h("143"), e;
        }
      },
      createRef: function createRef() {
        return {
          current: null
        };
      },
      Component: O,
      PureComponent: S,
      createContext: function createContext(e, t) {
        return void 0 === t && (t = null), (e = {
          $$typeof: f,
          _calculateChangedBits: t,
          _currentValue: e,
          _currentValue2: e,
          _threadCount: 0,
          Provider: null,
          Consumer: null
        }).Provider = {
          $$typeof: l,
          _context: e
        }, e.Consumer = e;
      },
      forwardRef: function forwardRef(e) {
        return {
          $$typeof: d,
          render: e
        };
      },
      lazy: function lazy(e) {
        return {
          $$typeof: m,
          _ctor: e,
          _status: -1,
          _result: null
        };
      },
      memo: function memo(e, t) {
        return {
          $$typeof: v,
          type: e,
          compare: void 0 === t ? null : t
        };
      },
      useCallback: function useCallback(e, t) {
        return N().useCallback(e, t);
      },
      useContext: function useContext(e, t) {
        return N().useContext(e, t);
      },
      useEffect: function useEffect(e, t) {
        return N().useEffect(e, t);
      },
      useImperativeHandle: function useImperativeHandle(e, t, n) {
        return N().useImperativeHandle(e, t, n);
      },
      useDebugValue: function useDebugValue() {},
      useLayoutEffect: function useLayoutEffect(e, t) {
        return N().useLayoutEffect(e, t);
      },
      useMemo: function useMemo(e, t) {
        return N().useMemo(e, t);
      },
      useReducer: function useReducer(e, t, n) {
        return N().useReducer(e, t, n);
      },
      useRef: function useRef(e) {
        return N().useRef(e);
      },
      useState: function useState(e) {
        return N().useState(e);
      },
      Fragment: c,
      StrictMode: a,
      Suspense: y,
      createElement: C,
      cloneElement: function cloneElement(e, t, n) {
        null == e && h("267", e);
        var o = void 0,
            i = r({}, e.props),
            c = e.key,
            a = e.ref,
            s = e._owner;

        if (null != t) {
          void 0 !== t.ref && (a = t.ref, s = P.current), void 0 !== t.key && (c = "" + t.key);
          var l = void 0;

          for (o in e.type && e.type.defaultProps && (l = e.type.defaultProps), t) {
            k.call(t, o) && !x.hasOwnProperty(o) && (i[o] = void 0 === t[o] && void 0 !== l ? l[o] : t[o]);
          }
        }

        if (1 === (o = arguments.length - 2)) i.children = n;else if (1 < o) {
          l = Array(o);

          for (var f = 0; f < o; f++) {
            l[f] = arguments[f + 2];
          }

          i.children = l;
        }
        return {
          $$typeof: u,
          type: e.type,
          key: c,
          ref: a,
          props: i,
          _owner: s
        };
      },
      createFactory: function createFactory(e) {
        var t = C.bind(null, e);
        return t.type = e, t;
      },
      isValidElement: I,
      version: "16.8.6",
      unstable_ConcurrentMode: p,
      unstable_Profiler: s,
      __SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED: {
        ReactCurrentDispatcher: E,
        ReactCurrentOwner: P,
        assign: r
      }
    },
        B = {
      default: V
    },
        D = B && V || B;
    e.exports = D.default || D;
  }, function (e, t, n) {
    "use strict";
    /*
    object-assign
    (c) Sindre Sorhus
    @license MIT
    */

    var r = Object.getOwnPropertySymbols,
        o = Object.prototype.hasOwnProperty,
        u = Object.prototype.propertyIsEnumerable;
    e.exports = function () {
      try {
        if (!Object.assign) return !1;
        var e = new String("abc");
        if (e[5] = "de", "5" === Object.getOwnPropertyNames(e)[0]) return !1;

        for (var t = {}, n = 0; n < 10; n++) {
          t["_" + String.fromCharCode(n)] = n;
        }

        if ("0123456789" !== Object.getOwnPropertyNames(t).map(function (e) {
          return t[e];
        }).join("")) return !1;
        var r = {};
        return "abcdefghijklmnopqrst".split("").forEach(function (e) {
          r[e] = e;
        }), "abcdefghijklmnopqrst" === Object.keys(Object.assign({}, r)).join("");
      } catch (e) {
        return !1;
      }
    }() ? Object.assign : function (e, t) {
      for (var n, i, c = function (e) {
        if (null == e) throw new TypeError("Object.assign cannot be called with null or undefined");
        return Object(e);
      }(e), a = 1; a < arguments.length; a++) {
        for (var s in n = Object(arguments[a])) {
          o.call(n, s) && (c[s] = n[s]);
        }

        if (r) {
          i = r(n);

          for (var l = 0; l < i.length; l++) {
            u.call(n, i[l]) && (c[i[l]] = n[i[l]]);
          }
        }
      }

      return c;
    };
  }, function (e, t, n) {
    "use strict";

    var r = n(9);

    function o() {}

    function u() {}

    u.resetWarningCache = o, e.exports = function () {
      function e(e, t, n, o, u, i) {
        if (i !== r) {
          var c = new Error("Calling PropTypes validators directly is not supported by the `prop-types` package. Use PropTypes.checkPropTypes() to call them. Read more at http://fb.me/use-check-prop-types");
          throw c.name = "Invariant Violation", c;
        }
      }

      function t() {
        return e;
      }

      e.isRequired = e;
      var n = {
        array: e,
        bool: e,
        func: e,
        number: e,
        object: e,
        string: e,
        symbol: e,
        any: e,
        arrayOf: t,
        element: e,
        elementType: e,
        instanceOf: t,
        node: e,
        objectOf: t,
        oneOf: t,
        oneOfType: t,
        shape: t,
        exact: t,
        checkPropTypes: u,
        resetWarningCache: o
      };
      return n.PropTypes = n, n;
    };
  }, function (e, t, n) {
    "use strict";

    e.exports = "SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED";
  }, function (e, t, n) {
    var r,
        o,
        u = n(2),
        i = n(3),
        c = 0,
        a = 0;

    e.exports = function (e, t, n) {
      var s = t && n || 0,
          l = t || [],
          f = (e = e || {}).node || r,
          p = void 0 !== e.clockseq ? e.clockseq : o;

      if (null == f || null == p) {
        var d = u();
        null == f && (f = r = [1 | d[0], d[1], d[2], d[3], d[4], d[5]]), null == p && (p = o = 16383 & (d[6] << 8 | d[7]));
      }

      var y = void 0 !== e.msecs ? e.msecs : new Date().getTime(),
          v = void 0 !== e.nsecs ? e.nsecs : a + 1,
          m = y - c + (v - a) / 1e4;
      if (m < 0 && void 0 === e.clockseq && (p = p + 1 & 16383), (m < 0 || y > c) && void 0 === e.nsecs && (v = 0), v >= 1e4) throw new Error("uuid.v1(): Can't create more than 10M uuids/sec");
      c = y, a = v, o = p;
      var b = (1e4 * (268435455 & (y += 122192928e5)) + v) % 4294967296;
      l[s++] = b >>> 24 & 255, l[s++] = b >>> 16 & 255, l[s++] = b >>> 8 & 255, l[s++] = 255 & b;
      var h = y / 4294967296 * 1e4 & 268435455;
      l[s++] = h >>> 8 & 255, l[s++] = 255 & h, l[s++] = h >>> 24 & 15 | 16, l[s++] = h >>> 16 & 255, l[s++] = p >>> 8 | 128, l[s++] = 255 & p;

      for (var g = 0; g < 6; ++g) {
        l[s + g] = f[g];
      }

      return t || i(l);
    };
  }, function (e, t, n) {
    var r = n(2),
        o = n(3);

    e.exports = function (e, t, n) {
      var u = t && n || 0;
      "string" == typeof e && (t = "binary" === e ? new Array(16) : null, e = null);
      var i = (e = e || {}).random || (e.rng || r)();
      if (i[6] = 15 & i[6] | 64, i[8] = 63 & i[8] | 128, t) for (var c = 0; c < 16; ++c) {
        t[u + c] = i[c];
      }
      return t || o(i);
    };
  }]);
});